<template>
  <div class="primeagent-back">
    <div class="primeagent-wrap">

      <!--MV-->
      <section class="first">
        <img src="/static/renew3_img/yagiprime_lp/mv_catch.png" alt="新卒キャンペーンヤギプライム" class="mv_catch">
        <div class="renew2_wrapper">
          <img src="/static/renew3_img/yagiprime_lp/mv_h2.png" alt="専任エージェントでチャンスをつかめ" class="mv_h2">
          <div class="mv_bottom">
            <img src="/static/renew3_img/yagiprime_lp/mv_lead.png" alt="ズボラでも大丈夫！" class="mv_lead">
            <a href="/yagiprime_register" class="cv-btn">エージェントを利用する</a>
            <div class="f-memo">
              <p>※エージェントに相談するために履歴書を作成</p>
            </div>
          </div>
        </div>
      </section>

      <!--流れ-->
      <section class="second">
        <div class="renew2_wrapper">
          <h3 class="a-h3"><img src="/static/renew3_img/yagiprime_lp/h3_second.png" alt="ご利用の流れ" class="a-h3img"></h3>
          <div class="sp_flex flex s-flow">
            <img src="/static/renew3_img/yagiprime_lp/deco03.png" alt="自己PRもAIが作成！" class="s-left">
            <ul class="s-right">
              <li class="s-flow-item">
                <h4 class="s-h4">履歴書作成</h4>
                <p class="s-txt">専用の履歴書テンプレートで履歴書を入力して作成する</p>
              </li>
              <li class="s-flow-item">
                <h4 class="s-h4">希望条件</h4>
                <p class="s-txt">希望条件を設定する</p>
              </li>
              <li class="s-flow-item">
                <h4 class="s-h4">専任エージェント配属</h4>
                <p class="s-txt">専任エージェントから連絡が来るのを待つ</p>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <!--ヤギプライムって？-->
      <section class="third">
        <div class="renew2_wrapper">
          <h3 class="a-h3"><img src="/static/renew3_img/yagiprime_lp/h3_third.png" alt="ヤギプライムって？" class="a-h3img"></h3>
          <img src="/static/renew3_img/yagiprime_lp/about01.png" alt="会員登録者数" class="t-aboutuser">
          <p class="t-abouttxt">ブラウザ上で履歴書がつくれる「yagish」から<br>便利な機能がたくさんついた新サービスです。</p>
          <img src="/static/renew3_img/yagiprime_lp/about02.png" alt="機能一覧" class="t-aboutlist">
        </div>
      </section>

      <!--メッセージ-->
      <section class="forth">
        <div class="d-back"></div>
        <div class="f-wrap">
          <img src="/static/renew3_img/yagiprime_img/logo.svg" alt="yagiprime" class="f-logo renew2_wrapper">
          <p class="f-txt renew2_wrapper">
            ヤギプライムは、ヤギッシュの各種サービスを完全無料または一部無料で利用できるほか、面倒な仕事探しが不要になり、志望動機は生成AIで作成することが可能です。時代に合わせて働き方は変化し、ヤギッシュのサービスも常にアップデートしていきます。
          </p>

          <div class="f-bottom">
            <div class="renew2_wrapper">
              <a href="/yagiprime_register" class="cv-btn">エージェントを利用する</a>
              <div class="f-memo">
                <p>※エージェントに相談するために履歴書を作成</p>
                <p>※¥550（税込）／月。いつでもキャンセル可能</p>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  </div>
</template>

<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style scoped>
.primeagent-back {
  background: #EEF5E8;
}

.primeagent-wrap {
  width: 400px;
  max-width: 100%;
  margin: 0 auto;
  background: #fff;
}

.renew2_wrapper {
  padding: 0 20px;
}

.primeagent-wrap .cv-btn {
  position: relative;
  display: block;
  width: 300px;
  padding: 12px 0;
  margin: 0 auto;
  background: #e3165c;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  text-align: center;
  margin-bottom: 10px;
  transition-duration: .4s;
}

.primeagent-wrap .cv-btn:hover {
  -webkit-transform: scale(1.05);
  transform: scale(1.05);
  text-decoration: none;
  opacity: 1;
}

.primeagent-wrap .cv-btn:after {
  content: "";
  width: 13px;
  height: 13px;
  border: 0;
  border-top: 2px solid #fff;
  border-right: 2px solid #fff;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  top: 0;
  right: 20px;
  bottom: 0;
  margin: auto;
}

.primeagent-wrap .cv-btn:hover {
  text-decoration: none;
  opacity: 1;
}

.primeagent-wrap .a-h3 {
  position: relative;
  display: inline-block;
  text-align: center;
  margin-bottom: 30px;
  z-index: 5;
}

.primeagent-wrap .a-h3:before {
  position: absolute;
  content: "\25CF";
  color: #f6f075;
  font-size: 50px;
  top: -30px;
  left: -30px;
  z-index: -1;
}

.primeagent-wrap .a-h3:after {
  position: absolute;
  content: "";
  background-image: url(/static/renew3_img/yagiprime_lp/deco02.png);
  background-repeat: no-repeat;
  background-size: contain;
  top: -20px;
  right: -55px;
  width: 50px;
  height: 50px;
  z-index: -1;
}

.primeagent-wrap .a-h3img {
  height: 26px;
  width: auto;
}

.primeagent-wrap .first {
  background: url(/static/renew3_img/yagiprime_lp/back.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 0;
  background-color: rgba(255, 255, 255, 0.3);
  background-blend-mode: lighten;
}

.primeagent-wrap .mv_bottom {
  position: relative;
  text-align: center;
  margin-top: 70px;
  z-index: 5;
}

.primeagent-wrap .mv_bottom:before {
  position: absolute;
  content: "";
  background-image: url(/static/renew3_img/yagiprime_lp/deco01.png);
  background-repeat: no-repeat;
  background-size: contain;
  top: -110px;
  left: 0;
  width: 141px;
  height: 120px;
}

.primeagent-wrap .mv_catch {
  width: 360px;
  -o-object-fit: contain;
  object-fit: contain;
}

.primeagent-wrap .mv_h2 {
  position: relative;
  width: 350px;
  height: auto;
  top: -60px;
  z-index: 6;
}

.primeagent-wrap .mv_lead {
  width: 360px;
  margin-bottom: 10px;
}

.primeagent-wrap .forth,
.primeagent-wrap .second,
.primeagent-wrap .third {
  padding: 50px 0;
}

.primeagent-wrap .second {
  position: relative;
  background: #eef5e8;
  text-align: center;
  padding-top: 120px;
  top: -55px;
  margin-bottom: -55px;
}

.primeagent-wrap .s-flow {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: end;
  -ms-flex-align: end;
  align-items: end;
  text-align: left;
}

.primeagent-wrap .s-left {
  width: 150px;
}

.primeagent-wrap .s-right {
  width: calc(100% - 160px);
}

.primeagent-wrap .s-flow-item {
  margin-bottom: 20px;
}

.primeagent-wrap .s-flow-item:last-child {
  margin-bottom: 0;
}

.primeagent-wrap .s-h4 {
  position: relative;
  font-size: 18px;
  color: #004d40;
}

.primeagent-wrap .third {
  position: relative;
  text-align: center;
}

.primeagent-wrap .third:after {
  position: absolute;
  content: "";
  background-image: url(/static/renew3_img/yagiprime_lp/deco04.png);
  background-repeat: no-repeat;
  background-size: contain;
  bottom: -80px;
  right: 10px;
  width: 107px;
  height: 115px;
  z-index: 6;
}

.primeagent-wrap .t-aboutuser {
  width: 240px;
  margin-bottom: 20px;
}

.primeagent-wrap .t-abouttxt {
  margin-bottom: 20px;
}

.primeagent-wrap .t-aboutlist {
  width: 100%;
  max-width: 394px;
}

.primeagent-wrap .forth {
  position: relative;
  text-align: center;
  overflow: hidden;
  z-index: 5;
  padding-bottom: 0;
}

.primeagent-wrap .d-back {
  position: relative;
  height: 50px;
}

.primeagent-wrap .d-back:before {
  position: absolute;
  content: "";
  width: 460px;
  height: 300px;
  border-radius: 250px 250px 0 0;
  background: #eef5e8;
  top: 0;
  right: calc(50% - 230px);
  z-index: -1;
}

.primeagent-wrap .f-logo {
  width: 120px;
  height: auto;
  margin-bottom: 30px;
}

.primeagent-wrap .f-txt {
  text-align: left;
  margin-bottom: 30px;
}

.primeagent-wrap .f-bottom {
  background: #eef5e8;
  padding-bottom: 50px;
}

.primeagent-wrap .f-memo {
  text-align: center;
  font-size: 12px;
}

.primeagent-wrap .mv_bottom::after {
  position: absolute;
  content: "";
  background-image: url(/static/renew3_img/yagiprime_lp/deco05.png);
  background-repeat: no-repeat;
  background-size: contain;
  bottom: 55px;
  right: -20px;
  width: 205px;
  height: 370px;
  z-index: -2;
}
</style>

<script>
export default {
  data: function () {
    return {}
  },
  computed: {},
  methods: {},
  watch: {},
  created: function () {

    const app = this

    app.$cookies.config(60 * 60 * 24, '')

    var route_id = app.$cookies.get('_YAGISH_YAGIPRIME_ROUTE_ID')
    app.$cookies.set('_YAGISH_YAGIPRIME_ROUTE_ID', route_id + '#agent_lp', null, null, 'yagish.jp')
    app.$cookies.set('_YAGISH_YAGIPRIME_ROUTE_ID', 'agent_lp', null, null, 'localhost')
  },
  mounted: function () { }
}
</script>
